export const SNACKBAR_TRANSITION_DURATION_IN = 300; // in ms
export const SNACKBAR_TRANSITION_DURATION_OUT = 200; // in ms
export const SNACKBAR_DEFAULT_DURATION = 3000; // in ms
export const BREAKPOINT_MEDIUM = 896;
export const BREAKPOINT_LARGE = 1200;
